<template>
  <div class="page">

    <img src="@/assets/008.jpg" class="banner" alt="banner" />
    <img src="@/assets/009.jpg" class="banner" alt="banner" />


  </div>
</template>

<script>
export default {
  name: 'Page2'
}
</script>

<style scoped>
.banner{
  max-width: 100%;
   
}
</style>